import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=afec7650&scoped=true&"
import script from "./EventListItem.vue?vue&type=script&lang=js&"
export * from "./EventListItem.vue?vue&type=script&lang=js&"
import style0 from "./EventListItem.vue?vue&type=style&index=0&id=afec7650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afec7650",
  null
  
)

export default component.exports